import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import models.GameRepository

class BankoGameScreenViewModel(
    private val gameCode: String,
    private val playerName: String,
    private val gameRepository: GameRepository
) : ViewModel() {

    private val bankoGameScreenUseCase = BankoGameScreenUseCase(gameRepository, viewModelScope, gameCode, playerName)
    val bankoGameScreenUiState = bankoGameScreenUseCase()

    override fun onCleared() {
        super.onCleared()
        // Leaving the game: stop suppressing ads on the host-perks basis (the buyer's own
        // entitlement still applies independently via RemoveAdsPurchases).
        bankoGameScreenUiState.onScreenClosed()
    }
}
